import { ComponentProps } from "react";
import * as S from "./styles";

export interface IInputCheckSlideProps extends ComponentProps<"input"> {
  label?: string;
}

export const InputSwitch = (props: IInputCheckSlideProps) => {
  return (
    <S.CustomLabel>
      <S.CustomInput
        {...props}
        onChange={(e) => {
          props?.onChange && props?.onChange(e);
        }}
        type="checkbox"
        id="customCheck"
      />
      {props?.label && <span>{props.label}</span>}
    </S.CustomLabel>
  );
};
